'use client';

import Script from 'next/script';

import { useConsent } from '@/lib/useConsent';

const COUNTER_ID = 108667098;
const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export function YandexMetrika() {
	const consent = useConsent();
	if (!IS_PRODUCTION || consent !== 'accepted') return null;

	return (
		<Script id="yandex-metrika" strategy="afterInteractive">
			{`
	(function(m,e,t,r,i,k,a){
	    m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
	    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
})(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js?id=${COUNTER_ID}', 'ym');

ym(${COUNTER_ID}, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true
	});
	`}
		</Script>
	);
}
